import { Link } from "react-router-dom";
import { hotEvents } from "@/mocks/events";
import { SectionHeading } from "@/components/base/Shared";
import Reveal from "@/components/base/Reveal";

const icons: Record<string, string> = {
  商业争议: "ri-briefcase-4-line",
  带货翻车: "ri-shopping-bag-3-line",
  人设崩塌: "ri-user-unfollow-line",
  情感纠纷: "ri-heart-3-line",
  网红言论: "ri-chat-quote-line",
};

const descs: Record<string, string> = {
  商业争议: "合约、分成、定价与外泄录音",
  带货翻车: "选品、宣称与售后引发的舆情",
  人设崩塌: "履历、旧言与身份被逐条核验",
  情感纠纷: "关系破裂、直播对峙与聊天记录",
  网红言论: "直播失言、截图扩散与二次解读",
};

export default function CategoryGrid() {
  const categories = Array.from(new Set(hotEvents.map((e) => e.category)));

  return (
    <section id="categories" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="TOPIC TAXONOMY"
          title="按主题分类，找到你想追的那一类"
          desc="不同类型的黑曝事件扩散逻辑差异很大。先选分类，再对比同一类事件的热度曲线，更容易看出规律。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((category, index) => {
            const count = hotEvents.filter((e) => e.category === category).length;
            const totalTopic = hotEvents
              .filter((e) => e.category === category)
              .reduce((sum, e) => sum + e.topicCount, 0);
            return (
              <Reveal key={category} delay={index * 70}>
                <Link
                  to={`/events?category=${encodeURIComponent(category)}`}
                  className="group flex items-start gap-4 h-full rounded-2xl bg-background-50 border border-background-200 hover:border-primary-300 p-6 transition-colors"
                >
                  <span className="w-12 h-12 shrink-0 rounded-xl bg-background-100 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className={`${icons[category] || "ri-hashtag"} text-xl`} />
                  </span>
                  <div className="flex-1">
                    <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                      {category}
                    </h3>
                    <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                      {descs[category]}
                    </p>
                    <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <span className="w-4 h-4 flex items-center justify-center text-accent-600">
                          <i className="ri-file-list-3-line" />
                        </span>
                        {count} 个在追事件
                      </span>
                      <span className="flex items-center gap-1">
                        <span className="w-4 h-4 flex items-center justify-center text-secondary-600">
                          <i className="ri-chat-3-line" />
                        </span>
                        话题量 {totalTopic}万
                      </span>
                    </div>
                  </div>
                  <span className="w-5 h-5 flex items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors">
                    <i className="ri-arrow-right-line" />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}